export const APP_FILE_CUSTOMERS_LIST = "/view-customers";
export const APP_FILE_CUSTOMER_OVERVIEW = "/customer-overview/:id";
export const APP_FILE_CREATE_CUSTOMER = "/create-customer";
export const APP_FILE_EDIT_CUSTOMER = "/edit-customer";